<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="SERIES1">The Gospel and Our Culture Series</p>
<p class="SERIES2">A series to foster the missional encounter of the gospel<br/>with North American culture</p>
<p class="SERIES3">John R. Franke<br/><span class="generaleditor _idGenCharOverride-1">General Editor</span><br/><br/>•  •</p>
<p class="SERIES4">  Volumes Published to Date  </p>
<p class="SERIES5">Lois Y. Barrett et al., <em class="italic">Treasure in Clay Jars: Patterns in Missional Faithfulness</em></p>
<p class="SERIES5">James V. Brownson, Inagrace T. Dietterich, Barry A. Harvey,<br/>and Charles C. West, <em class="italic">StormFront: The Good News of God</em></p>
<p class="SERIES5">Michael J. Gorman, <em class="italic">Becoming the Gospel: Paul, Participation, and Mission</em></p>
<p class="SERIES5">Darrell L. Guder, <em class="italic">The Continuing Conversion of the Church</em></p>
<p class="SERIES5">Darrell L. Guder et al., <em class="italic">Missional Church: A Vision for the<br/>Sending of the Church in North America</em></p>
<p class="SERIES5">George R. Hunsberger, <em class="italic">Bearing the Witness of the Spirit:<br/>Lesslie Newbigin’s Theology of Cultural Plurality</em></p>
<p class="SERIES5">George R. Hunsberger, <em class="italic">The Story That Chooses Us:<br/>A Tapestry of Missional Vision</em></p>
<p class="SERIES5">George R. Hunsberger and Craig Van Gelder, editors, <em class="italic">The Church between Gospel and Culture: The Emerging Mission in North America</em></p>
<p class="SERIES5">Craig Van Gelder, editor, <em class="italic">Confident Witness — Changing World:<br/>Rediscovering the Gospel in North America</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Gorman_Becoming_the_Gospel_text_CC.vue?1b4ac368